unit uSubForm1;

interface

uses
  SysUtils, Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  WEBLib.Controls, WEBLib.StdCtrls, WEBLib.Grids, WEBLib.DBCtrls,
  WEBLib.ExtCtrls, WEBLib.CDS, DB, WEBLib.DB,
  WEBLib.Buttons, WEBLib.Imaging.pngimage;

type
  TSubForm1 = class(TForm)
    WebLabel1: TLabel;
    txtSelection: TLabel;
    WebDBEdit1: TDBEdit;
    WebDBGrid1: TDBGrid;
    WebDBEdit2: TDBEdit;
    WebDataSource4: TDataSource;
    WebClientDataSet4: TClientDataSet;
    WebClientConnection4: TClientConnection;
    WebBitBtn2: TBitBtn;
    WebDBEdit3: TDBEdit;
    WebLabel2: TLabel;
    WebLabel3: TLabel;
    WebLabel4: TLabel;
    WebLabel5: TLabel;
    WebLabel6: TLabel;
    WebImageControl1: TImageControl;
    WebLabel7: TLabel;
    procedure WebBitBtn1Click(Sender: TObject);
    procedure WebBitBtn9Click(Sender: TObject);
    procedure WebBitBtn10Click(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebBitBtn2Click(Sender: TObject);
    procedure WebDBGrid1Click(Sender: TObject);
  protected
    procedure LoadDFMValues; override;

  end;

var
  SubForm1: TSubForm1;

implementation


uses  uFrmMain;

procedure TSubForm1.WebBitBtn10Click(Sender: TObject);
var   AF : String;
begin
end;

procedure TSubForm1.WebBitBtn1Click(Sender: TObject);
var    edvalid, edinvalid: string;
begin
if WebClientConnection4.Active=false then begin
     WebClientConnection4.URI := 'data/cities.json';
      WebClientConnection4.Active := true;
end;
end;

procedure TSubForm1.WebBitBtn2Click(Sender: TObject);
var  NAS, MIA  : String;
begin
  MIA:=WEBDBEdit1.Text;
  NAS:=WEBDBEdit2.Text;
  ShowMessage('Nasłonecznienie dla miasta '+MIA+' wynosi : '+NAS);
end;

procedure TSubForm1.WebBitBtn9Click(Sender: TObject);
var   IL     : Integer;
begin
end;

procedure TSubForm1.WebDBGrid1Click(Sender: TObject);
var   DIC               : String;
begin
  DIC:=WEBDBEdit1.Text+'.png';
  WebImageControl1.URL:='img\'+DIC;
   frmMain.txtSampleText.Text:=WebDBEdit1.Text;
   frmMain.WebEdit1.Text:=WebDBEdit2.Text;

end;

procedure TSubForm1.WebFormCreate(Sender: TObject);
var    edvalid, edinvalid: string;

begin
if WebClientConnection4.Active=false then begin
     WebClientConnection4.URI := 'data/cities.json';
      WebClientConnection4.Active := true;
end;
//SubForm1.Refresh;
FrmMain.txtSampleText.Text:='Białystok';
FrmMain.WebEdit1.Text:='1215,14';
//FrmMain.Refresh;
end;

procedure TSubForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebLabel1 := TLabel.Create(Self);
  txtSelection := TLabel.Create(Self);
  WebLabel2 := TLabel.Create(Self);
  WebLabel3 := TLabel.Create(Self);
  WebLabel4 := TLabel.Create(Self);
  WebLabel5 := TLabel.Create(Self);
  WebLabel6 := TLabel.Create(Self);
  WebImageControl1 := TImageControl.Create(Self);
  WebLabel7 := TLabel.Create(Self);
  WebDBEdit1 := TDBEdit.Create(Self);
  WebDBGrid1 := TDBGrid.Create(Self);
  WebDBEdit2 := TDBEdit.Create(Self);
  WebBitBtn2 := TBitBtn.Create(Self);
  WebDBEdit3 := TDBEdit.Create(Self);
  WebDataSource4 := TDataSource.Create(Self);
  WebClientDataSet4 := TClientDataSet.Create(Self);
  WebClientConnection4 := TClientConnection.Create(Self);

  WebLabel1.BeforeLoadDFMValues;
  txtSelection.BeforeLoadDFMValues;
  WebLabel2.BeforeLoadDFMValues;
  WebLabel3.BeforeLoadDFMValues;
  WebLabel4.BeforeLoadDFMValues;
  WebLabel5.BeforeLoadDFMValues;
  WebLabel6.BeforeLoadDFMValues;
  WebImageControl1.BeforeLoadDFMValues;
  WebLabel7.BeforeLoadDFMValues;
  WebDBEdit1.BeforeLoadDFMValues;
  WebDBGrid1.BeforeLoadDFMValues;
  WebDBEdit2.BeforeLoadDFMValues;
  WebBitBtn2.BeforeLoadDFMValues;
  WebDBEdit3.BeforeLoadDFMValues;
  WebDataSource4.BeforeLoadDFMValues;
  WebClientDataSet4.BeforeLoadDFMValues;
  WebClientConnection4.BeforeLoadDFMValues;
  try
    Name := 'SubForm1';
    Left := 0;
    Top := 0;
    Width := 640;
    Height := 450;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, Self, 'OnCreate', 'WebFormCreate');
    WebLabel1.SetParentComponent(Self);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 8;
    WebLabel1.Top := 77;
    WebLabel1.Width := 70;
    WebLabel1.Height := 16;
    WebLabel1.Caption := 'Lokalizacja';
    WebLabel1.Font.Charset := DEFAULT_CHARSET;
    WebLabel1.Font.Color := clMenuHighlight;
    WebLabel1.Font.Height := 16;
    WebLabel1.Font.Name := 'Tahoma';
    WebLabel1.Font.Style := [fsBold];
    WebLabel1.ParentFont := False;
    txtSelection.SetParentComponent(Self);
    txtSelection.Name := 'txtSelection';
    txtSelection.Left := 16;
    txtSelection.Top := 221;
    txtSelection.Width := 3;
    txtSelection.Height := 13;
    WebLabel2.SetParentComponent(Self);
    WebLabel2.Name := 'WebLabel2';
    WebLabel2.Left := 240;
    WebLabel2.Top := 389;
    WebLabel2.Width := 51;
    WebLabel2.Height := 13;
    WebLabel2.Caption := 'Lokalizacja';
    WebLabel3.SetParentComponent(Self);
    WebLabel3.Name := 'WebLabel3';
    WebLabel3.Left := 367;
    WebLabel3.Top := 389;
    WebLabel3.Width := 47;
    WebLabel3.Height := 13;
    WebLabel3.Caption := 'Produkcja';
    WebLabel4.SetParentComponent(Self);
    WebLabel4.Name := 'WebLabel4';
    WebLabel4.Left := 513;
    WebLabel4.Top := 389;
    WebLabel4.Width := 77;
    WebLabel4.Height := 13;
    WebLabel4.Caption := 'Nas'#322'onecznienie';
    WebLabel5.SetParentComponent(Self);
    WebLabel5.Name := 'WebLabel5';
    WebLabel5.Left := 439;
    WebLabel5.Top := 408;
    WebLabel5.Width := 56;
    WebLabel5.Height := 13;
    WebLabel5.Caption := '{kWh/kWp}';
    WebLabel6.SetParentComponent(Self);
    WebLabel6.Name := 'WebLabel6';
    WebLabel6.Left := 586;
    WebLabel6.Top := 408;
    WebLabel6.Width := 47;
    WebLabel6.Height := 13;
    WebLabel6.Caption := '[kWh/m2]';
    WebImageControl1.SetParentComponent(Self);
    WebImageControl1.Name := 'WebImageControl1';
    WebImageControl1.Left := 219;
    WebImageControl1.Top := 76;
    WebImageControl1.Width := 414;
    WebImageControl1.Height := 290;
    WebImageControl1.ChildOrder := 12;
    WebImageControl1.Picture.LoadFromFile('uSubForm1.WebImageControl1.Picture.png');
    WebLabel7.SetParentComponent(Self);
    WebLabel7.Name := 'WebLabel7';
    WebLabel7.Left := 8;
    WebLabel7.Top := 428;
    WebLabel7.Width := 211;
    WebLabel7.Height := 13;
    WebLabel7.Caption := 'Kalkulator fotowoltaiczny - Pro-Sun (c) 2020';
    WebLabel7.Color := clYellow;
    WebLabel7.Transparent := False;
    WebDBEdit1.SetParentComponent(Self);
    WebDBEdit1.Name := 'WebDBEdit1';
    WebDBEdit1.Left := 236;
    WebDBEdit1.Top := 405;
    WebDBEdit1.Width := 110;
    WebDBEdit1.Height := 19;
    WebDBEdit1.ChildOrder := 1;
    WebDBEdit1.Color := 16777200;
    WebDBEdit1.Enabled := False;
    WebDBEdit1.Text := 'WebDBEdit1';
    WebDBEdit1.DataField := 'Miasto';
    WebDBEdit1.DataSource := WebDataSource4;
    WebDBGrid1.SetParentComponent(Self);
    WebDBGrid1.Name := 'WebDBGrid1';
    WebDBGrid1.Left := 8;
    WebDBGrid1.Top := 99;
    WebDBGrid1.Width := 201;
    WebDBGrid1.Height := 323;
    WebDBGrid1.DataSource := WebDataSource4;
    WebDBGrid1.FixedCols := 0;
    WebDBGrid1.TabOrder := 1;
    SetEvent(WebDBGrid1, Self, 'OnClick', 'WebDBGrid1Click');
    WebDBEdit2.SetParentComponent(Self);
    WebDBEdit2.Name := 'WebDBEdit2';
    WebDBEdit2.Left := 367;
    WebDBEdit2.Top := 405;
    WebDBEdit2.Width := 65;
    WebDBEdit2.Height := 19;
    WebDBEdit2.ChildOrder := 9;
    WebDBEdit2.Color := clInfoBk;
    WebDBEdit2.Text := 'WebDBEdit2';
    WebDBEdit2.DataField := 'Nas'#322'onecznienie';
    WebDBEdit2.DataSource := WebDataSource4;
    WebBitBtn2.SetParentComponent(Self);
    WebBitBtn2.Name := 'WebBitBtn2';
    WebBitBtn2.Left := 540;
    WebBitBtn2.Top := 45;
    WebBitBtn2.Width := 80;
    WebBitBtn2.Height := 25;
    WebBitBtn2.Caption := 'Warto'#347#263;
    WebBitBtn2.Color := clBtnFace;
    WebBitBtn2.TabOrder := 3;
    WebBitBtn2.Visible := False;
    SetEvent(WebBitBtn2, Self, 'OnClick', 'WebBitBtn2Click');
    WebDBEdit3.SetParentComponent(Self);
    WebDBEdit3.Name := 'WebDBEdit3';
    WebDBEdit3.Left := 513;
    WebDBEdit3.Top := 405;
    WebDBEdit3.Width := 66;
    WebDBEdit3.Height := 19;
    WebDBEdit3.ChildOrder := 6;
    WebDBEdit3.Color := clInfoBk;
    WebDBEdit3.Text := 'WebDBEdit3';
    WebDBEdit3.DataField := 'Produkcja';
    WebDBEdit3.DataSource := WebDataSource4;
    WebDataSource4.SetParentComponent(Self);
    WebDataSource4.Name := 'WebDataSource4';
    WebDataSource4.DataSet := WebClientDataSet4;
    WebDataSource4.Left := 574;
    WebDataSource4.Top := 101;
    WebClientDataSet4.SetParentComponent(Self);
    WebClientDataSet4.Name := 'WebClientDataSet4';
    WebClientDataSet4.Connection := WebClientConnection4;
    WebClientDataSet4.Left := 470;
    WebClientDataSet4.Top := 101;
    WebClientConnection4.SetParentComponent(Self);
    WebClientConnection4.Name := 'WebClientConnection4';
    WebClientConnection4.Active := False;
    WebClientConnection4.Left := 358;
    WebClientConnection4.Top := 101;
  finally
    WebLabel1.AfterLoadDFMValues;
    txtSelection.AfterLoadDFMValues;
    WebLabel2.AfterLoadDFMValues;
    WebLabel3.AfterLoadDFMValues;
    WebLabel4.AfterLoadDFMValues;
    WebLabel5.AfterLoadDFMValues;
    WebLabel6.AfterLoadDFMValues;
    WebImageControl1.AfterLoadDFMValues;
    WebLabel7.AfterLoadDFMValues;
    WebDBEdit1.AfterLoadDFMValues;
    WebDBGrid1.AfterLoadDFMValues;
    WebDBEdit2.AfterLoadDFMValues;
    WebBitBtn2.AfterLoadDFMValues;
    WebDBEdit3.AfterLoadDFMValues;
    WebDataSource4.AfterLoadDFMValues;
    WebClientDataSet4.AfterLoadDFMValues;
    WebClientConnection4.AfterLoadDFMValues;
  end;
end;

end.
